import { makeCygnusApiCall } from "../../../api/api";
import { CustomToaster } from "../../../pages/reusable_components/Toasters/toaster";

/**
 * Downloads a file using the Cygnus API wrapper.
 */
export const downloadFile = async (
  endpoint: string, 
  params: any,
  isPayloadAFile: boolean = false
): Promise<Blob> => {
  const payload = params;

  CustomToaster({
    type: "info",
    customized_message: "⏳ Preparing your spreadsheet...",
    api_message: "",
    auto_close: 3500
  });

  const response = await makeCygnusApiCall({
    type: "POST",
    url: endpoint,
    payload,
    payload_is_file: isPayloadAFile,
    show_message: false,
    isblob: true,
    forMDM: true,
  });

  return response;
};